'use client';
import { AutocompleteResponse, RecentSearchDto } from '@/api/search';
import Typography from '@/components/primitives/typography';
import Container from '@/components/primitives/container';
import { X } from 'lucide-react';
import styles from './styles.module.scss';

interface SearchMainViewProps {
  searchKeyword: string;
  autocomplete: AutocompleteResponse | null;
  recentSearches: RecentSearchDto[];
  selectedIndex?: number;
  onSearch: (keyword: string) => void;
  onDeleteRecentSearch: (keyword: string) => void;
}

const SearchMainView = ({
  searchKeyword,
  autocomplete,
  recentSearches,
  selectedIndex = -1,
  onSearch,
  onDeleteRecentSearch,
}: SearchMainViewProps) => {
  const items = autocomplete?.items || [];

  return (
    <div
      className={styles.container}
      onClick={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <Container blur={true} className={styles.dropdownInner}>
        <div className={styles.autocompleteList}>
          {!searchKeyword && recentSearches.length > 0 && (
            <div className={styles.section}>
              <Typography weight="bold" className={styles.sectionTitle}>
                최근 검색어
              </Typography>
              {recentSearches.map((item, index) => (
                <div
                  key={item.keyword}
                  className={`${styles.item} ${selectedIndex === index ? styles.itemSelected : ''}`}
                  onMouseDown={() => onSearch(item.keyword)}
                >
                  <div className={styles.keywordArea}>
                    <Typography>{item.keyword}</Typography>
                  </div>
                  <button
                    className={styles.deleteButton}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteRecentSearch(item.keyword);
                    }}
                  >
                    <X width={16} height={16} color="#999" />
                  </button>
                </div>
              ))}
            </div>
          )}

          {searchKeyword && items.length > 0 && (
            <div className={styles.section}>
              <Typography weight="bold" className={styles.sectionTitle}>
                검색어 자동 완성
              </Typography>
              {items.map((item, index) => (
                <div
                  key={item.keyword}
                  className={`${styles.item} ${selectedIndex === index ? styles.itemSelected : ''}`}
                  onMouseDown={() => onSearch(item.keyword)}
                >
                  <div className={styles.keywordArea}>
                    <Typography>{item.keyword}</Typography>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default SearchMainView;
